import { useRestClient } from '@/contexts/QueryProvider'
// import { json } from '../../../mock-data/templates/templates-state-variants-showcase.json'
// import { TemplateSummaryResponse } from './types'
import { useAppContext } from '@/catalog-apps/hooks/useAppContext'

// const mockData = json as TemplateSummaryResponse[]

export function useGetTemplatesSummary({
  appId: appIdProp,
  projectId: projectIdProp,
}: {
  appId?: number
  projectId?: number
}) {
  const { getTemplatesApiGetTemplateSummary } = useRestClient()
  const { appId: appIdContext, projectId: projectIdContext } = useAppContext()
  return getTemplatesApiGetTemplateSummary.useSuspenseQuery(
    { path: { applicationId: appIdProp || appIdContext!, projectId: projectIdProp || projectIdContext! } }
    // { select: (_) => mockData }
  )
}

export function useInvalidateTemplatesSummary() {
  const { getTemplatesApiGetTemplateSummary } = useRestClient()
  // const { appId, projectId } = useAppContext()
  // return () =>
  //   getTemplatesApiGetTemplateSummary.invalidateQueries({
  //     parameters: { path: { applicationId: appId!, projectId: projectId! } },
  //   })
  return () => getTemplatesApiGetTemplateSummary.invalidateQueries()
}
